import { authGet, authPost } from '../../../lib';
import type { PrintOrderPackageLabelResponse } from '../../../types';

export interface ExpressPalletSession {
  moveablePalletID: number;
  warehouseID: number;
  warehouseLocationName?: string;
  remainingQuantity: number;
  pendingLabels: number;
  activeUsers: number;
  isComplete: boolean;
  pendingLabel?: PrintOrderPackageLabelResponse | null;
  lastPrintedLabel?: PrintOrderPackageLabelResponse | null;
}

export const expressSessionChanged = 'express-pallet-session-changed';
const baseUrl = 'orders/express-pallet-session';
interface SessionResponse {
  session: ExpressPalletSession | null;
}

export async function readExpressSession() {
  return authGet<SessionResponse>(baseUrl);
}

export async function changeExpressSession(action: string) {
  const result = await authPost<SessionResponse>(`${baseUrl}/${action}`, {});
  if (!result.error && result.data) {
    window.dispatchEvent(
      new CustomEvent(expressSessionChanged, { detail: result.data.session }),
    );
  }
  return result;
}
